import React, { useState, useRef } from "react";
import Author from "./Author";
import ResearchStyle from "../../../style/helperCSS/Research.module.css";

const Research = (props) => {
  const [expanded, setExpanded] = useState(false);
  const abstractRef = useRef(null);
  const toggleExpanded = () => {
    setExpanded(!expanded);
    if (expanded) {
      abstractRef.current.scrollIntoView();
    }
  };
  return (
    <div className={`row ${ResearchStyle.Research_component}`}>
      <div className={`col-12`}>
        <div className={`row`}>
          <h3 className={`${ResearchStyle.paper_title}`}>{props.title}</h3>
          <a href={props.journal_link} target="_blank" className={`mt-12 ${ResearchStyle.journal_name}`}>
            {" "}
            {props.journal_name}
          </a>
          <div className={`mt-25 ${ResearchStyle.publication_details}`}>
            <div className={`${ResearchStyle.publication_type}`}>
              <button>{props.publication_type}</button>
              <button>{props.date}</button>
              <button>Citations {props.citation}</button>
              <a href={props.pdf_link} className={`${ResearchStyle.pdf_div}`} target="_blank">
                <p>PDF</p>
                <img src="assets/icons/education-icons/pdf.svg" alt="" />
              </a>
            </div>
            <div className={`${ResearchStyle.doi}`}>
              <p>
                DOI :{" "}
                <a href={props.doi_url} target="_blank">
                  {" "}
                  {props.doi}
                </a>
              </p>
            </div>
          </div>
          <Author authors={props.authors} />

          <div className={` mt-40 ${ResearchStyle.abstract_row}`} ref={abstractRef}>
            <div className={`${ResearchStyle.abstract_col}`}>
              <p className={`${ResearchStyle.keywords}`}>
                <b>Keywords: </b>
                <p>{props.keywords}</p>
              </p>
              <p
                className={`mt-15 ${ResearchStyle.abstract} ${ResearchStyle.p1}`}
                style={{
                  maxHeight: expanded ? "none" : "calc(1.7em * " + 8 + ")",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <b> Abstract: </b>
                {props.abstract}
              </p>
              <p className={`mt-15 ${ResearchStyle.abstract}  ${ResearchStyle.p2}`}>
                <b> Abstract: </b>
                {props.abstract}
              </p>
              <button className={`${ResearchStyle.view_details_button}`} onClick={toggleExpanded}>
                {expanded ? "View Less" : "View More"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Research;
